import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-right",
  templateUrl: "./med-icon-border-right.component.html",
})
export class MedIconBorderRightComponent extends SvgMixinComponent {}
